import { useSelector } from 'react-redux';
import { RootState } from '../store/indexRedux';

import Loading from '../components/ui/Loading';
import ProductServiceSummary from '../components/activeServices/ProductServiceSummary';

function Homepage() {
  const { loading } = useSelector((state: RootState) => state.selectedCompany);

  if (loading) {
    return <Loading />;
  }

  return (
    <>
      {/* <CompanyServiceCount /> */}
      <ProductServiceSummary />
    </>
  );
}
export default Homepage;
